import React from 'react';
import { motion } from 'framer-motion';
import { useLanguage } from '../context/LanguageContext';
import { t } from '../data/translations';

const partners = [
  ['HSV Systemverkehre GmbH', 'B&B TEAM, s.r.o.', 'Star Internationale Transporte Deutschland GmbH', 'S.T. Transport s. r. o.', 'Boyens Spedition GmbH & Co. KG', 'QCZ DachBau GmbH'],
  ['Great Spirit s. r. o.', 'In time express s.r.o.', 'EHOSS s. r. o.', 'DALITRANS, s.r.o.', 'RDT logistics s.r.o.', 'Cestovná kancelária DAKA s.r.o.'],
  ['EXPRES KURIÉR Nitra s.r.o.', 'GARTNER GmbH', 'DO&DO CARGO s. r. o.', 'KLEMON MODE, s.r.o.']
];

const PartnerRow = ({ items, direction = 'left', speed = 40 }) => {
  const duplicated = [...items, ...items, ...items];
  
  return (
    <div className="relative overflow-hidden py-2">
      <motion.div
        className="flex gap-4"
        animate={{
          x: direction === 'left' ? [0, -140 * items.length] : [-140 * items.length, 0],
        }}
        transition={{
          x: {
            repeat: Infinity,
            repeatType: "loop",
            duration: speed,
            ease: "linear",
          },
        }}
      >
        {duplicated.map((name, index) => (
          <motion.div
            key={`${name}-${index}`}
            whileHover={{ scale: 1.05, y: -2 }}
            className="flex-shrink-0 px-6 py-3 bg-gray-50 rounded-xl border border-gray-100 hover:border-[#E8A238] hover:shadow-lg transition-all cursor-pointer min-w-[130px] flex items-center justify-center"
          >
            <span className="text-[#131132] font-semibold text-sm whitespace-nowrap">{name}</span>
          </motion.div>
        ))}
      </motion.div>
    </div>
  );
};

const IntegrationsSection = () => {
  const { language } = useLanguage();

  return (
    <section className="bg-white py-28 overflow-hidden">
      <div className="max-w-7xl mx-auto px-6">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="text-center mb-16"
        >
          <h2 className="text-4xl md:text-5xl lg:text-6xl font-bold text-[#131132] mb-6">
            {t('partners.title', language)}
          </h2>
          <p className="text-xl text-[#131132]/60 max-w-3xl mx-auto">
            {t('partners.subtitle', language)}
          </p>
        </motion.div>

        {/* Scrolling Partners */}
        <div className="space-y-3">
          <PartnerRow items={partners[0]} direction="left" speed={45} />
          <PartnerRow items={partners[1]} direction="right" speed={40} />
          <PartnerRow items={partners[2]} direction="left" speed={50} />
        </div>
      </div>
    </section>
  );
};

export default IntegrationsSection;
